import { Routes } from '@angular/router';
import { AuthGuard } from '@auth';

export const routes: Routes = [
  // Angular-owned routes — all other URLs are handled by ui-router via HybridUrlHandlingStrategy
  { path: 'login', pathMatch: 'full', redirectTo: '/' },
  {
    path: '',
    canActivate: FEATURE_BODACDC_167 ? [AuthGuard] : [],
    children: [
      ...(FEATURE_BODACDC_2405
        ? [
            {
              path: 'settings/batching-rules',
              canActivate: [AuthGuard],
              loadChildren: () =>
                import('./routes/settings/batching-rules/batching-rules.routes').then(m => m.batchingRulesRoutes),
              title: 'Batching Rules',
            },
          ]
        : []),
      ...(FEATURE_BODACDC_3966
        ? [
            {
              path: 'messages',
              canActivate: [AuthGuard],
              loadComponent: () =>
                import('./routes/messages/messages.container').then(m => m.MessagesContainerComponent),
              title: 'Messages',
            },
          ]
        : []),
    ],
  },
];
